<script lang="ts" module>
	export const symbolId = "ishavskraft-icon-right-arrow";
	export const symbol = `
		<symbol id="${symbolId}" viewBox="0 0 20 14">
			<path d="M13 14L11.6 12.6L16.2 8H0V6H16.2L11.6 1.4L13 0L20 7L13 14Z" />
		</symbol>`;
</script>

<script lang="ts">
	import type { ClassValue } from "svelte/elements";

	let {
		class: classes = null,
		ariaHidden = true,
	}: {
		class?: ClassValue | null;
		ariaHidden?: boolean;
	} = $props();
</script>

<svg
	aria-hidden={ariaHidden}
	width="20"
	height="14"
	viewBox="0 0 20 14"
	xmlns="http://www.w3.org/2000/svg"
	class={classes}
	fill="currentcolor"
>
	<use href="#{symbolId}" />
</svg>
